<template>
  <div>
    <div
      class="screen-overlay"
      :class="{'screen-overlay--visible': menuOpen}"
      @click="toggleMenu()"
    />
    <div
      id="off-canvas-menu"
      :class="{'open': menuOpen}"
      @click="toggleMenu()"
    >
      <font-awesome-icon
        :icon="['fal', 'bars']"
        class="icon alt"
      />
      <font-awesome-icon
        :icon="['fal', 'times']"
        class="icon alt"
      />
    </div>
    <transition name="slide">
      <div
        v-show="menuOpen"
        class="off-canvas-menu__drawer"
      >
        <div
          class="off-canvas-menu__header"
        />
        <navigation-menu
          :on-click="onClickNav"
        />
        <header-buttons />
      </div>
    </transition>
  </div>
</template>

<script>
import NavigationMenu from '@/components/NavigationMenu.vue';
import HeaderButtons from '@/components/HeaderButtons.vue';

export default {
  name: 'OffCanvasMenu',
  components: {
    NavigationMenu,
    HeaderButtons,
  },
  data: () => ({
    menuOpen: false,
  }),
  watch: {
    menuOpen(menuOpen) {
      if (menuOpen) {
        document.documentElement.style.overflow = 'hidden';
        // document.documentElement is the same as using document.querySelector('#root')
      } else {
        document.documentElement.style.overflow = 'auto';
      }
    },
    $route() {
      this.menuOpen = false;
    },
  },
  created() {
    document.addEventListener('keydown', this.closeMenuWithEsc);
  },
  destroyed() {
    document.removeEventListener('keydown', this.closeMenuWithEsc);
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    closeMenuWithEsc(e) {
      if (e.keyCode === 27 && this.menuOpen) {
        this.menuOpen = false;
      }
    },
    onClickNav() {
      this.menuOpen = false;
    },
  },
};
</script>

<style lang="scss">
  #off-canvas-menu {
    position: fixed;
    top: 4px;
    right: 0;
    z-index: 10;
    display: block;
    width: 70px;
    height: 70px;
    cursor: pointer;

    svg {
      position: absolute;
      top: 16px;
      right: 26px;
      font-size: 28px;
      transform: rotate(0);
      transform-origin: center center;
      opacity: 1;
      transition: all 0.2s ease;

      &.fa-times {
        top: 16px;
        right: 28px;
        font-size: 30px;
        opacity: 0;
      }
    }

    &.open {
      svg {
        color: rgba($white, 0.7);
        transform: rotate(180deg);
        opacity: 0;

        &.fa-times {
          opacity: 1;

          &:hover {
            color: rgba($white, 0.9);
          }
        }
      }
    }
  }

  .off-canvas-menu__header {
    position: relative;
    height: $header-height;
    background: $black;

    &__close-button {
      position: absolute;
      top: 22px;
      left: 16px;
      z-index: 3;
      color: rgba($white, 0.6);

      svg {
        font-size: 30px;
      }

      &:hover {
        color: white;
        cursor: pointer;
      }
    }
  }

  .off-canvas-menu__drawer {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 9;
    width: 300px;
    height: 100vh;
    background: $light-gray;
    box-shadow:
      0 14px 28px rgba($black, 0.25),
      0 10px 10px rgba($black, 0.22);

    ul {
      margin-bottom: 0;
      padding-left: 0;
      text-align: left;
      list-style: none;
    }

    li {
      font-size: 14px;
      border-bottom: $default-border;
    }

    a,
    .link {
      position: relative;
      display: block;
      width: 100%;
      height: 55px;
      padding-left: 15px;
      color: #555;
      font-weight: bold;
      font-size: 15px;
      line-height: 55px;
      text-transform: uppercase;

      &:hover {
        color: #555;
        background: $secondary-border;
      }

      .fa-chevron-right {
        position: absolute;
        top: 20px;
        right: 15px;
        display: block;
        color: rgba($black, 0.6);
        font-size: 16px;
        opacity: 0.67;
      }
    }

    /deep/ .header-buttons {
      padding: 15px;
      padding-top: 20px;

      li {
        display: block;
        width: 100%;
        margin-bottom: 5px;
        border-bottom: none;

        button {
          display: block;
          width: 100%;
          padding: calc(#{$gutter} / 2);
        }
      }
    }
  }

  .screen-overlay {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 8;
    width: 0;
    height: 0;
    background: $black;
    opacity: 0;
    transition: opacity 0.2s ease-out;

    &--visible {
      width: 100vw;
      height: 100vh;
      opacity: 0.7;
      transition: opacity 0.2s ease-out;
    }
  }

  .slide-enter-active,
  .slide-leave-active {
    transform: translateX(0);
    transition: all 0.2s ease-out;
  }

  .slide-enter,
  .slide-leave-to {
    transform: translateX(300px);
    transition: all 0.2s ease;
  }
</style>
